import React from "react";
import { Company } from "../../types/investorDashboardTypes";

interface Props {
  companies: Company[];
}

const CompanyTable: React.FC<Props> = ({ companies }) => {
    if (!companies || !Array.isArray(companies)) {
    return <p className="text-center text-gray-500">Loading or no data.</p>;
  }
  return (
    <table className="w-full border-collapse text-sm">
      <thead>
        <tr className="bg-[#072928]">
          <th className="p-2 border text-white">Company</th>
          <th className="p-2 border text-white">Country</th>
          <th className="p-2 border text-white">LinkedIn</th>
          <th className="p-2 border text-white">Email</th>
          <th className="p-2 border text-white">Website</th>
          <th className="p-2 border text-white">Phone</th>
          <th className="p-2 border text-white">Industries</th>
          <th className="p-2 border text-white">Investor Type</th>
          <th className="p-2 border text-white">Investments</th>
          <th className="p-2 border text-white">Exits</th>
        </tr>
      </thead>
      <tbody>
        
        {companies.map((company) => (
          <tr key={company.id} className="even:bg-gray-50">
            <td className="p-2 border">{company.company_name}</td>
            <td className="p-2 border">{company.country}</td>
            <td className="p-2 border">
              {company.linkedin ? (
                <a href={company.linkedin} target="_blank" rel="noreferrer" className="text-blue-600 underline">
                  LinkedIn
                </a>
              ) : (
                "-"
              )}
            </td>
            <td className="p-2 border">{company.contact_email || "-"}</td>
            <td className="p-2 border">
              {company.company_url ? (
                <a href={company.company_url} target="_blank" rel="noreferrer" className="text-blue-600 underline">
                  Website
                </a>
              ) : (
                "-"
              )}
            </td>
            <td className="p-2 border">{company.phone_number || "-"}</td>
            <td className="p-2 border">{company.industries?(company.industries):"-"}</td>
            <td className="p-2 border">{company.investor_type}</td>
            <td className="p-2 border text-green-600">
              {company.number_of_investments || "0"}
            </td>
            <td className="p-2 border text-red-500">
              {company.number_of_exits || "0"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CompanyTable;
